<div class="evaluation__card">
	<div class="zk-flex zk-flex-col zk-gap-2 md:zk-flex-row zk-justify-between">
		<span class="evaluation__title">{{ title }}</span>
		<div class="zk-flex zk-gap-2 zk-items-center">
			<span class="freud-icon freud-icon-calendar"></span>
			<span class="evaluation__date">{{ formatedDate(date) }}</span>
		</div>
	</div>
	<div
		class="instruments__wrapper zk-mt-5"
		[ngClass]="{ 'zk-justify-end': instruments.length === 0 }"
	>
		<div class="instruments">
			<div class="instrument" *ngFor="let instrument of instruments">
				<span>{{ instrument.title }}</span>
				<div
					freud-tooltip
					[tooltipLabel]="instrument.tag.tooltip"
					class="tag"
					[ngStyle]="{ 'background-color': instrument.tag.color }"
				>
					{{ instrument.tag.text }}
				</div>
			</div>
		</div>
		<div
			class="zk-flex zk-gap-3 evaluation__button"
			(click)="openDetail.emit()"
		>
			<span>{{ 'EVALUATIONS.SEE_ANSWERS' | translate }}</span>
			<span class="freud-icon freud-icon-chevron-right freud-icon-md"></span>
		</div>
	</div>
</div>
